import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { arrayOf, bool, func, shape, string, number, oneOfType, oneOf } from 'prop-types';
import React, { useState } from 'react';
import { DynamicText } from '../../molecules';
import { Item as ItemElement } from '../../atoms';
import { Container, HorizontalRule, Title, List, Item } from './text-list.styles';

const TextList = _ref => {
  let {
    hideListPoint,
    limitListItems,
    list,
    handleClickLink,
    showAllItems,
    showMoreLabel,
    title,
    titleAs,
    typeList
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["hideListPoint", "limitListItems", "list", "handleClickLink", "showAllItems", "showMoreLabel", "title", "titleAs", "typeList"]);

  const [showAll, setShowAll] = useState(showAllItems);
  const [items, setItems] = useState(list.slice(0, limitListItems));

  const handleShowMore = () => {
    setShowAll(true);
    setItems(list);
  };

  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "text-list-container"
  }, props, {
    variation: typeList
  }), title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    "data-testid": "text-list-title",
    as: titleAs,
    variation: typeList
  }, title), typeList !== 'inline' && /*#__PURE__*/React.createElement(HorizontalRule, {
    variation: typeList
  })), /*#__PURE__*/React.createElement(List, {
    "data-testid": "text-list-ul",
    variation: typeList
  }, items.map((line, index) => /*#__PURE__*/React.createElement(Item, {
    variation: typeList,
    hide: !showAll && index >= limitListItems,
    key: index,
    "data-testid": "text-list-text",
    hideListPoint: hideListPoint
  }, /*#__PURE__*/React.createElement(DynamicText, {
    data: line,
    handleClickLink: handleClickLink
  })))), !showAll && items.length >= limitListItems && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HorizontalRule, null), /*#__PURE__*/React.createElement(ItemElement, {
    fontWeight: "medium",
    fontSize: 1,
    color: "text.primary",
    fill: "text.primary",
    startIcon: "ChevronDownCircle",
    variant: "transparent",
    gap: 1,
    centered: true,
    onClick: handleShowMore,
    "data-testid": "term-list-more"
  }, showMoreLabel)));
};

TextList.defaultProps = {
  hideListPoint: false,
  limitListItems: 20,
  list: [],
  handleClickLink: () => {},
  showAllItems: true,
  showMoreLabel: 'veja mais',
  title: null,
  titleAs: 'h1',
  typeList: 'default'
};
process.env.NODE_ENV !== "production" ? TextList.propTypes = {
  hideListPoint: bool,
  limitListItems: number,
  list: arrayOf(arrayOf(oneOfType([string, shape({})]))),
  handleClickLink: func,
  showAllItems: bool,
  showMoreLabel: string,
  title: string,
  titleAs: string,
  typeList: oneOf(['default', 'flex', 'inline'])
} : void 0;
export default TextList;